import type { DocumentLocale } from '../utils/documentLocale';

export const LATEST_TERMS_OF_USE_VERSION = '1.0.0';

export const termsOfUseJsonUrl = (
    version: string,
    locale: DocumentLocale = 'tr'
): string => {
    const fileName =
        locale === 'en' ? `${version}.en.json` : `${version}.json`;
    return `${process.env.PUBLIC_URL}/terms/${fileName}`;
};
